import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import Modal from '../../components/modal/Modal';
import { Col, getSatisfactionReturnEmojiText, Row } from '../../lib/utils';
import { LatestSessionReview } from '../../services/useFeedDashboardQueryService';
import { colors } from '../../lib/colors';
import { DemiLightText, MediumText, RegularText } from '../../lib/Text';
import SvgIcon from '../../components/SvgIcon';
import dayjs from 'dayjs';
import FeedCenterStatisticsGoodPercent from './Icon/FeedCenterStatisticsGoodPercentIcon';
import { useNavigate } from 'react-router-dom';

type Props = {
    setIsVisible: Dispatch<SetStateAction<boolean>>;
    sessionReview?: LatestSessionReview;
};

const ModalFeedCoachStatisticsPageAllMember = ({ setIsVisible, sessionReview }: Props) => {
    const navigate = useNavigate();
    // 강사 숨김 여부
    // const isCoachHidden = sessionReview?.isCoachHidden || false;
    const isCoachHidden = false; // 임시로 false로 설정

    const memberId = sessionReview?.memberId || '';
    const coachId = sessionReview?.coachId || '';
    const score = sessionReview?.score || 0;
    const content = sessionReview?.content || '';
    const createdAt = dayjs(sessionReview?.createdAt).format('MM.DD (ddd) HH:mm');
    const scheduleStartTime = dayjs(sessionReview?.scheduleStartTime).format('MM.DD (ddd) HH:mm');
    const coachName = sessionReview?.coachName || '';
    const memberName = sessionReview?.memberName || '';
    const isAnonymous = sessionReview?.isAnonymous || false;
    // 회차
    const session = sessionReview?.session || 0;

    const rightInfoRef = useRef<HTMLDivElement>(null);
    const [rightInfoWidth, setRightInfoWidth] = useState(0);

    useEffect(() => {
        if (rightInfoRef.current) {
            setRightInfoWidth(rightInfoRef.current.offsetWidth);
        }
    }, [sessionReview]);

    // HTML 엔티티 디코딩 함수
    const decodeHtmlEntities = (text: string): string => {
        return text
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&amp;/g, '&')
            .replace(/&quot;/g, '"')
            .replace(/&#x27;/g, "'")
            .replace(/&#x2F;/g, '/');
    };

    return (
        <Modal setIsVisible={setIsVisible} whiteViewWidth={600} borderRadius={25}>
            <Col className="flex w-full h-full py-[25px] px-[35px]">
                <Row className="flex w-full items-center mb-[21px]">
                    <MediumText fontSize={25} lineHeight={30} color={colors.Text_1}>
                        💬 수업 리뷰
                    </MediumText>
                    {isAnonymous && (
                        <Row className="flex items-center bg-Text_1 ml-[12px] rounded-[8px] px-[7px] py-[7px]">
                            <SvgIcon name="SvgSecretReview" size={17} fill={colors.white} className="mr-[4px]" />
                            <DemiLightText fontSize={12} lineHeight={17} color={colors.white}>
                                리뷰
                            </DemiLightText>
                        </Row>
                    )}
                </Row>
                <Row className="flex w-full justify-between gap-[17px] pr-[29px] mb-[16.75px]">
                    <Row className="flex items-center">
                        <RegularText fontSize={16} lineHeight={21} color={'#8D95A0'} className="mr-[12px]">
                            강사
                        </RegularText>
                        <RegularText fontSize={18} lineHeight={23} color={colors.Text_1}>
                            {coachName}
                        </RegularText>
                    </Row>
                    <Row className="flex items-center">
                        <RegularText fontSize={16} lineHeight={21} color={'#8D95A0'} className="mr-[12px]">
                            회원
                        </RegularText>
                        <RegularText fontSize={18} lineHeight={23} color={colors.Text_1}>
                            {memberName}
                        </RegularText>
                    </Row>
                    <Row className="flex items-center" ref={rightInfoRef}>
                        <Col className="flex items-center mr-[12px] bg-[#C9DBFF66] px-[7px] py-[3px] rounded-[5px] ">
                            <DemiLightText fontSize={13} lineHeight={18} color={colors.primary}>
                                {session}회차
                            </DemiLightText>
                        </Col>
                        <DemiLightText fontSize={18} lineHeight={23} color={colors.Text_1}>
                            {scheduleStartTime}
                        </DemiLightText>
                    </Row>
                </Row>
                <Row className="flex w-full justify-between gap-[17px] pr-[29px] mb-[19px]">
                    <Row className="flex items-center">
                        <FeedCenterStatisticsGoodPercent iconSize={13} width={26.25} height={26.25} />
                        <RegularText fontSize={18} lineHeight={23} color={colors.Text_1}>
                            {score}%
                        </RegularText>
                    </Row>
                    <Row className="flex items-center">
                        <RegularText fontSize={23} lineHeight={28} color={colors.Text_1} className="mr-[14px]">
                            {getSatisfactionReturnEmojiText(score).emoji}
                        </RegularText>
                        <RegularText fontSize={18} lineHeight={23} color={colors.Text_1}>
                            {getSatisfactionReturnEmojiText(score).text}
                        </RegularText>
                    </Row>
                    <Col style={{ width: rightInfoWidth }} />
                </Row>
                <Col className="flex w-full h-[0.75px] border-b border-[#EBEBEB] border-solid mb-[23px]" />
                <Col className="flex w-full h-full mb-[60px]">
                    <DemiLightText fontSize={17} lineHeight={23} color={colors.Text_1}>
                        {decodeHtmlEntities(content) || '리뷰 내용이 없습니다.'}
                    </DemiLightText>
                </Col>
                <Row className="flex w-full items-center justify-end">
                    <Col
                        className="flex items-center justify-center w-[182px] h-[49px] bg-[#F2F4F6] rounded-[10px] cursor-pointer mr-[12px]"
                        onClick={() => {
                            navigate('/feed/member', {
                                state: {
                                    coachId,
                                    memberId,
                                },
                            });
                        }}
                    >
                        <RegularText fontSize={18} lineHeight={23} color={colors.Text_1}>
                            일지 바로 가기
                        </RegularText>
                    </Col>
                    <Col
                        className="flex items-center justify-center w-[182px] h-[49px] bg-primary rounded-[10px] cursor-pointer"
                        onClick={() => setIsVisible(false)}
                    >
                        <RegularText fontSize={18} lineHeight={23} color={colors.white}>
                            확인
                        </RegularText>
                    </Col>
                </Row>
            </Col>
        </Modal>
    );
};

export default ModalFeedCoachStatisticsPageAllMember;
